import {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {PoligonoService} from "saneamiento/service";
import {poligono_view_adapter} from "saneamiento/model";
import {EntityCreatePage} from "base/entity";
import {PoligonoForm} from "../presentational/form";

const CreatePoligonoPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const basePath = location.pathname.split("/new")[0];
    const {codigo} = useParams();
    const codigoConcello = codigo;

    const [error, setError] = useState("");

    const handleFormSubmit = poligono => {
        PoligonoService.create(poligono_view_adapter({...poligono}))
            .then(createdPoligono => {
                navigate(`${basePath}/${createdPoligono.id}/summary`);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(basePath);
    };

    return (
        <EntityCreatePage
            form={
                <PoligonoForm
                    onSubmit={handleFormSubmit}
                    onCancel={handleFormCancel}
                    concello={codigoConcello}
                />
            }
            title="Rexistro de Polígono"
            error={error}
        />
    );
};

export default CreatePoligonoPage;
